/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationSegmentsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationSegmentsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationSegmentsQuery = {
  __typename?: 'Query';
  internalRegulationSegments: {
    __typename?: 'InternalRegulationSegmentConnection';
    edges: Array<{
      __typename?: 'InternalRegulationSegmentEdge';
      cursor: string;
      node: {
        __typename?: 'InternalRegulationSegment';
        id: string;
        reference?: string | null;
        sectionName?: string | null;
        fragmentGroups?: Array<{
          __typename?: 'InternalRegulationFragmentGroup';
          id: string;
          fragments?: Array<{
            __typename?: 'InternalRegulationFragment';
            id: string;
            label?: string | null;
            body?: string | null;
          }> | null;
        }> | null;
      };
    }>;
    pageInfo: { __typename?: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationSegmentsDocument = gql`
  query InternalRegulationSegments($input: InternalRegulationSegmentsInput, $first: Int, $after: String) {
    internalRegulationSegments(input: $input, first: $first, after: $after) {
      edges {
        node {
          id
          reference
          sectionName
          fragmentGroups {
            id
            fragments {
              id
              label
              body
            }
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationSegmentsQuery__
 *
 * To run a query within a React component, call `useInternalRegulationSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationSegmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationSegmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>(
    InternalRegulationSegmentsDocument,
    options,
  );
}
export function useInternalRegulationSegmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationSegmentsQuery,
    IInternalRegulationSegmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>(
    InternalRegulationSegmentsDocument,
    options,
  );
}
// @ts-ignore
export function useInternalRegulationSegmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationSegmentsQuery,
    IInternalRegulationSegmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>;
export function useInternalRegulationSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationSegmentsQuery | undefined,
  IInternalRegulationSegmentsQueryVariables
>;
export function useInternalRegulationSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalRegulationSegmentsQuery, IInternalRegulationSegmentsQueryVariables>(
    InternalRegulationSegmentsDocument,
    options,
  );
}
export type InternalRegulationSegmentsQueryHookResult = ReturnType<typeof useInternalRegulationSegmentsQuery>;
export type InternalRegulationSegmentsLazyQueryHookResult = ReturnType<typeof useInternalRegulationSegmentsLazyQuery>;
export type InternalRegulationSegmentsSuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationSegmentsSuspenseQuery
>;
export type InternalRegulationSegmentsQueryResult = Apollo.QueryResult<
  IInternalRegulationSegmentsQuery,
  IInternalRegulationSegmentsQueryVariables
>;
